import { makeStyles } from '@material-ui/core/styles';

export const useResumesListStyles = makeStyles(
  theme => ({
    listContainer: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: theme.spacing(2)
    },
    scrollableContent: {
      flex: 1,
      overflow: 'auto',
      backgroundColor: theme.palette.background.paper,
      paddingRight: theme.spacing(1)
    },
    resultsHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1, 0),
      marginRight: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.divider}`
    }
  }),
  { name: 'ResumesList' }
);
